import React, { FC } from 'react';
import { Drawer, DrawerProps } from 'antd';
import styled from 'styled-components';
import theme from '~/theme';

interface Props {
  open: boolean;
  onClose: () => void;
  headerHeight: number;
}

const MobileHeaderContainer: FC<Props> = (props) => {
  const { children, open, onClose, headerHeight } = props;

  return (
    <Container
      visible={open}
      forceRender
      onClose={onClose}
      placement="bottom"
      closeIcon={null}
      headerHeight={headerHeight}
    >
      {children}
    </Container>
  );
};

interface UIProps extends DrawerProps {
  headerHeight: number;
}

const borderRadius = theme.borderRadiusBase * 2;

const Container = styled<FC<UIProps>>(Drawer as any)`
  .ant-drawer-content-wrapper {
    height: unset !important;
    display: block !important;
    border-radius: ${borderRadius}px ${borderRadius}px 0 0;
    transform: ${({ visible, headerHeight }) =>
      visible ? undefined : `translateY(100%) translateY(-${headerHeight}px) !important`};
    box-shadow: 0px 0px 7px 1px rgba(164, 175, 183, 0.3);
    .ant-drawer-content {
      border-radius: ${borderRadius}px ${borderRadius}px 0 0;
    }
    .ant-drawer-header {
      display: none;
    }
    .ant-drawer-close {
      display: none;
    }
    .ant-drawer-body {
      padding: 0 !important;
    }
  }
`;

export default MobileHeaderContainer;
